<script>
import {ref} from "vue";
import {useRoute} from "vue-router";
import Swal from "sweetalert2";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import FooterPage from "@/components/assetComponents/FooterPage.vue";

export default {
  name: "SelectProductsComparison",
  components: {FooterPage, NavbarPage, LoadingPage},

  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let loading = ref(false)

    let sub_cat_id = ref(useRoute().params.sub_cat_id)
    let prod_id_one = ref(useRoute().params.prod_id_one)

    let products = ref([])
    let productss = ref([])
    let mark_prod = ref([])
    let mark_prodd = ref([])

    let page = ref('all')

    let input_search = ref()

    function load_prods() {

      loading.value = true
      FreeWorld.Heisenberg({sub_category: sub_cat_id.value}, 'products', true).then((result) => {

        let res = result.data
        res.forEach((item) => {

          if (prod_id_one.value != item.id) {
            products.value.push(item)
          }

        })

        productss.value = products.value

      }).catch((result) => {

        loading.value = false

        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              load_prods()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              load_prods()
            }
          })
        }
      })


      FreeWorld.Heisenberg({
        action: 'show_product_mark',
        sub_cat: sub_cat_id.value,
      }, 'user_marke', true).then((result) => {

        loading.value = false
        let res = result.data

        res.forEach((item) => {
          if (prod_id_one.value != item.id) {
            mark_prod.value.push(item)
          }
        })
        mark_prodd.value = mark_prod.value

      }).catch((result) => {

        loading.value = false

        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              load_prods()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              load_prods()
            }
          })
        }
      })
    }
    load_prods()

    function search_prod() {

      products.value = []
      productss.value.forEach((item) => {
        if (item.name.includes(input_search.value)) {
          products.value.push(item)
        }
      })

      mark_prod.value = []
      mark_prodd.value.forEach((item) => {
        if (item.name.includes(input_search.value)) {
          mark_prod.value.push(item)
        }
      })

    }


    return {

      sub_cat_id,
      prod_id_one,
      loading,
      products,
      mark_prod,
      page,
      search_prod,
      input_search,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass' : '' " class="bg-main">
    <div class="div-top-arrow bg-color d-flex align-items-center justify-content-between z-3">
      <div class="d-flex align-items-center">

        <router-link :to="{name:'HomePage'}">
          <img class="svg-arrow" src="../assets/img/closing.svg" alt="">
        </router-link>

      </div>
      <div class="d-flex align-items-center">
        <p class="m-0 font-4">
          انتخاب کالا در این دسته بندی برای مقایسه
        </p>

        <div onclick="history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <div class="d-flex p-body justify-content-between mt-2">

      <input type="text" v-model="input_search" @input="search_prod" class="rounded-pill bg-white border-costom text-center w-60 py-3" placeholder="جستجو">
      <div v-if="page === 'all' " @click="page = 'marks'"
           class="rounded-pill d-flex justify-content-evenly align-items-center bg-color w-40 border-costom font-6 text-white">
        <img style="width: 15px" src="../assets/img/bookmark-white.svg" alt="">
        <p class="m-0">
          انتخاب از نشان شده ها
        </p>
      </div>

      <div v-else @click="page = 'all'"
           class="rounded-pill d-flex justify-content-evenly align-items-center bg-color w-40 border-costom font-6 text-white">
        <p class="m-0">
          تمامی محصولات
        </p>
      </div>

    </div>

    <br>


    <div v-if="page === 'all' " class="list_products p-body">

      <div v-if="products.length === 0 "
           class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
           style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/shop_none.svg" alt="">
          <br>
          <p class="font-4 ">
            در حال حاضر محصولی وجود ندارد...
          </p>
        </div>
      </div>

      <div v-else>

        <router-link v-for="item in products" :key="item.id"
                     :to="{name:'ComparisonProducts' , params:{sub_cat_id:sub_cat_id , prod_id_two:item.id , prod_id_one:prod_id_one}}"
                     class="animate__animated animate__fadeIn text-decoration-none rounded-shaped text-black products_custom d-flex justify-content-between mb-2 shadow-costom p-body">

          <div class="position-relative animated-background rounded-4 div_img_products">

            <img v-if="item.pic1 === null " class="img_products rounded-4" src="../assets/img/img-notavalible.jpg" alt="">
            <img v-else class="img_products rounded-4" :src="item.pic1" alt="">

            <div v-if="item.rating_product !== null"
                 class="div_stars py-1 px-2 rounded-pill d-flex position-absolute shadow-costom align-items-center">

              <img style="width: 1rem" src="../assets/img/star_gold.svg" alt="">

              <p class="font-5 mx-1 text-center">{{ item.rating_product }}</p>
            </div>

          </div>


          <div class="information_products overflow-hidden">
            <p class="font-4 font-bold" :class="item.name.length > 26 ? 'txtoverflow' : '' ">{{ item.name }}</p>
            <div class="my-1 d-flex justify-content-start align-items-center my-2">
              <div class="d-flex ml-2 overflow-hidden align-items-center">
                <img style="width: 15px" class="ml-2" src="../assets/img/shop.svg" alt="">
                <div class="overflow-hidden">
                  <p class="font-5" :class="item.unit_name.length > 18 ? 'txtoverflow' : '' ">{{ item.unit_name }}</p>
                </div>
              </div>
              <div v-if="item.rating_store != null" class="position-relative">
                <img style="height: 1.3rem" src="../assets/img/star_gold.svg" alt="">
                <p class="position-absolute font-6 text-white number_star">{{ item.rating_store }}</p>
              </div>
            </div>
            <div class="my-1 d-flex justify-content-between align-items-center">
              <div class="d-flex">
                <img style="width: 15px" src="../assets/img/list.svg" alt="">
                <p class="font-5 mx-2">{{ item.brand }}</p>
              </div>

              <div v-if="item.count == 0" class="existence rounded-pill">
                <p class="font-color font-6 px-2 py-1">
                  ناموجود
                </p>
              </div>
            </div>

            <hr>

            <div class="price_div d-flex justify-content-between">
              <div class="d-flex">

                <p :class="item.off_price != null ? 'text-decoration-line-through' : 'font-color' " class=" font-6">
                  <span class="">{{ item.price.toLocaleString() }}</span>

                  <span v-if="item.off_price == null" class="mx-1">تومان</span>
                </p>


                <p v-if="item.off_price != null" class="font-6 mx-2 font-color m-0">
                  <span class="">{{ item.off_price.toLocaleString() }}</span>

                  <span class="mx-1">تومان</span>
                </p>

              </div>


              <p v-if="item.off_price != null" class="off_percent font-6 rounded-pill font-color">
                <span>%</span>
                <span>{{ item.discount }}</span>
              </p>
            </div>
          </div>

        </router-link>

      </div>

    </div>

    <div v-if="page === 'marks' " class="list_products p-body">

      <div v-if="mark_prod.length === 0 " class="p-body w-100 d-flex flex-column justify-content-center align-items-center" style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/shop_none.svg" alt="">
          <br>
          <p class="font-4 ">
            در حال حاضر محصولی وجود ندارد...
          </p>
        </div>
      </div>

      <div v-else>

        <router-link v-for="item in mark_prod" :key="item.id"
                     :to="{name:'ComparisonProducts' , params:{sub_cat_id:sub_cat_id , prod_id_two:item.id , prod_id_one:prod_id_one}}"
                     class="animate__animated animate__fadeIn text-decoration-none rounded-shaped text-black products_custom d-flex justify-content-between mb-2 shadow-costom p-body">

          <div class="position-relative animated-background rounded-4 div_img_products">

            <img v-if="item.pic1 === null " class="img_products rounded-4" src="../assets/img/img-notavalible.jpg" alt="">
            <img v-else class="img_products rounded-4" :src="item.pic1" alt="">

            <div v-if="item.rating_product !== null"
                 class="div_stars py-1 px-2 rounded-pill d-flex position-absolute shadow-costom align-items-center">

              <img style="width: 1rem" src="../assets/img/star_gold.svg" alt="">

              <p class="font-5 mx-1 text-center">{{ item.rating_product }}</p>
            </div>

          </div>


          <div class="information_products overflow-hidden">
            <p class="font-4 font-bold" :class="item.name.length > 26 ? 'txtoverflow' : '' ">{{ item.name }}</p>
            <div class="my-1 d-flex justify-content-start align-items-center my-2">
              <div class="d-flex ml-2 overflow-hidden align-items-center">
                <img style="width: 15px" class="ml-2" src="../assets/img/shop.svg" alt="">
                <div class="overflow-hidden">
                  <p class="font-5" :class="item.name_store.length > 18 ? 'txtoverflow' : '' ">{{ item.name_store }}</p>
                </div>
              </div>
              <div v-if="item.rating_store != null" class="position-relative">
                <img style="height: 1.3rem" src="../assets/img/star_gold.svg" alt="">
                <p class="position-absolute font-6 text-white number_star">{{ item.rating_store }}</p>
              </div>
            </div>
            <div class="my-1 d-flex justify-content-between align-items-center">
              <div class="d-flex">
                <img style="width: 15px" src="../assets/img/list.svg" alt="">
                <p class="font-5 mx-2">{{ item.brand }}</p>
              </div>

              <div v-if="item.count == 0" class="existence rounded-pill">
                <p class="font-color font-6 px-2 py-1">
                  ناموجود
                </p>
              </div>
            </div>

            <hr>

            <div class="price_div d-flex justify-content-between">
              <div class="d-flex">

                <p :class="item.off_price != null ? 'text-decoration-line-through' : 'font-color' " class=" font-6">
                  <span class="">{{ item.price.toLocaleString() }}</span>

                  <span v-if="item.off_price == null" class="mx-1">تومان</span>
                </p>


                <p v-if="item.off_price != null" class="font-6 mx-2 font-color m-0">
                  <span class="">{{ item.off_price.toLocaleString() }}</span>

                  <span class="mx-1">تومان</span>
                </p>

              </div>


              <p v-if="item.off_price != null" class="off_percent font-6 rounded-pill font-color">
                <span>%</span>
                <span>{{ item.discount }}</span>
              </p>
            </div>
          </div>

        </router-link>

      </div>

    </div>

    <br>

  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="bg-main">
    <NavbarPage></NavbarPage>

    <div class="d-flex p-body justify-content-between mt-2">

      <input type="text" v-model="input_search" @input="search_prod"
             class="rounded-pill bg-white border-costom text-center w-50 py-3" placeholder="جستجو">

      <div v-if="page === 'all' " @click="page = 'marks'"
           class="rounded-pill d-flex justify-content-center align-items-center bg-color w-30 border-costom text-white">
        <img style="width: 1.5rem" class="mx-2" src="../assets/img/bookmark-white.svg" alt="">
        <p class="m-0 font-3">
          انتخاب از نشان شده ها
        </p>
      </div>

      <div v-else @click="page = 'all'"
           class="rounded-pill d-flex justify-content-center align-items-center bg-color w-30 border-costom text-white">
        <p class="m-0 font-3">
          تمامی محصولات
        </p>
      </div>

    </div>

    <br>

    <div v-if="page === 'all' " class="list_products p-body">

      <div v-if="products.length === 0 " class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
           style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/shop_none.svg" alt="">
          <br>
          <p class="font-4 ">
            در حال حاضر محصولی وجود ندارد...
          </p>
        </div>
      </div>

      <div v-else class="d-flex justify-content-center">
        <div class="list_products_web overflow-y-scroll bg-white rounded-4 p-3 w-90">
          <!--*** محصولات ***-->
          <router-link v-for="item in products" :key="item.id"  :to="{name:'ComparisonProducts' , params:{sub_cat_id:sub_cat_id , prod_id_two:item.id , prod_id_one:prod_id_one}}"
                       class="animate__animated animate__fadeIn rounded-shaped text-decoration-none text-black products_custom_web d-flex justify-content-between mb-3 shadow-costom p-body">

            <div class="position-relative animated-background rounded-4 div_img_products_web">

              <img v-if="item.pic1 == null " class="img_products rounded-4" src="../assets/img/img-notavalible.jpg" alt="">

              <img v-else class="img_products rounded-4" :src="item.pic1" alt="">

              <div v-if="item.rating_product != null"
                   class="div_stars py-1 px-2 rounded-pill d-flex position-absolute shadow-costom align-items-center">

                <img style="width: 20px" src="../assets/img/star_gold.svg" alt="">

                <p class="font-4 mx-1 text-center">{{ item.rating_product }}</p>
              </div>

            </div>


            <div class="information_products-web d-flex flex-column justify-content-evenly overflow-hidden">

              <p class="font-3 font-bold" :class="{'txtoverflow':item.name.length > 30}">{{ item.name }}</p>
              <div class="my-1 d-flex justify-content-start align-items-center">
                <div class="d-flex ml-2 overflow-hidden align-items-center">
                  <img style="width: 18px" class="ml-2" src="../assets/img/shop.svg" alt="">
                  <div class="overflow-hidden">
                    <p class="font-4" :class="{'txtoverflow':item.unit_name.length > 20}">{{ item.unit_name }}</p>
                  </div>
                </div>
                <div v-if="item.rating_store != null" class="position-relative">
                  <img style="height: 25px" src="../assets/img/star_gold.svg" alt="">
                  <p class="position-absolute font-5 text-white number_star">{{ item.rating_store }}</p>
                </div>
              </div>
              <div class="my-1 d-flex justify-content-between align-items-center">
                <div class="d-flex">
                  <img style="width: 18px" src="../assets/img/list.svg" alt="">
                  <p class="font-3 mx-2">{{ item.brand }}</p>
                </div>

                <div v-if="item.count == 0" class="existence rounded-pill">
                  <p class="font-color font-4 px-2 py-1">
                    ناموجود
                  </p>
                </div>
              </div>

              <hr>

              <div class="price_div d-flex justify-content-between">
                <div class="d-flex">

                  <p :class="item.off_price != null ? 'text-decoration-line-through' : 'font-color' " class=" font-3">
                    <span class="">{{ item.price.toLocaleString() }}</span>

                    <span v-if="item.off_price == null" class="mx-1">تومان</span>
                  </p>


                  <p v-if="item.off_price != null" class="font-3 mx-2 font-color m-0">
                    <span class="">{{ item.off_price.toLocaleString() }}</span>

                    <span class="mx-1">تومان</span>
                  </p>

                </div>


                <p v-if="item.off_price != null" class="off_percent font-4 rounded-pill font-color font-bold">
                  <span>%</span>
                  <span>{{ item.discount }}</span>
                </p>
              </div>
            </div>

          </router-link>
        </div>
      </div>

    </div>

    <div v-if="page === 'marks' " class="list_products p-body">

      <div v-if="mark_prod.length === 0 "
           class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
           style="height: 60vh">
        <div class="d-flex flex-column align-items-center">
          <img style="width: 70px" src="../assets/img/shop_none.svg" alt="">
          <br>
          <p class="font-4 ">
            در حال حاضر محصولی وجود ندارد...
          </p>
        </div>
      </div>

      <div v-else class="d-flex justify-content-center">
        <div class="list_products_web bg-white rounded-4 p-3 w-90">
          <!--*** محصولات ***-->
          <router-link v-for="item in mark_prod" :key="item.id" :to="{name:'ComparisonProducts' , params:{sub_cat_id:sub_cat_id , prod_id_two:item.id , prod_id_one:prod_id_one}}"
                       class="animate__animated animate__fadeIn rounded-shaped text-decoration-none text-black products_custom_web d-flex justify-content-between mb-3 shadow-costom p-body">

            <div class="position-relative animated-background rounded-4 div_img_products_web">

              <img v-if="item.pic1 == null " class="img_products rounded-4" src="../assets/img/img-notavalible.jpg"
                   alt="">

              <img v-else class="img_products rounded-4" :src="item.pic1" alt="">

              <div v-if="item.rating_product != null"
                   class="div_stars py-1 px-2 rounded-pill d-flex position-absolute shadow-costom align-items-center">

                <img style="width: 20px" src="../assets/img/star_gold.svg" alt="">

                <p class="font-4 mx-1 text-center">{{ item.rating_product }}</p>
              </div>

            </div>


            <div class="information_products-web d-flex flex-column justify-content-evenly overflow-hidden w-60">

              <p class="font-3 font-bold" :class="{'txtoverflow':item.name.length > 30}">{{ item.name }}</p>
              <div class="my-1 d-flex justify-content-start align-items-center">
                <div class="d-flex ml-2 overflow-hidden align-items-center">
                  <img style="width: 18px" class="ml-2" src="../assets/img/shop.svg" alt="">
                  <div class="overflow-hidden">
                    <p class="font-4" :class="{'txtoverflow':item.name_store.length > 15}">{{ item.name_store }}</p>
                  </div>
                </div>
                <div v-if="item.rating_store != null" class="position-relative">
                  <img style="height: 25px" src="../assets/img/star_gold.svg" alt="">
                  <p class="position-absolute font-5 text-white number_star">{{ item.rating_store }}</p>
                </div>
              </div>
              <div class="my-1 d-flex justify-content-between align-items-center">
                <div class="d-flex">
                  <img style="width: 18px" src="../assets/img/list.svg" alt="">
                  <p class="font-3 mx-2">{{ item.brand }}</p>
                </div>

                <div v-if="item.count == 0" class="existence rounded-pill">
                  <p class="font-color font-4 px-2 py-1">
                    ناموجود
                  </p>
                </div>
              </div>

              <hr>

              <div class="price_div d-flex justify-content-between">
                <div class="d-flex">

                  <p :class="item.off_price != null ? 'text-decoration-line-through' : 'font-color' " class=" font-3">
                    <span class="">{{ item.price.toLocaleString() }}</span>

                    <span v-if="item.off_price == null" class="mx-1">تومان</span>
                  </p>


                  <p v-if="item.off_price != null" class="font-3 mx-2 font-color m-0">
                    <span class="">{{ item.off_price.toLocaleString() }}</span>

                    <span class="mx-1">تومان</span>
                  </p>

                </div>


                <p v-if="item.off_price != null" class="off_percent font-4 rounded-pill font-color font-bold">
                  <span>%</span>
                  <span>{{ item.discount }}</span>
                </p>
              </div>
            </div>

          </router-link>
        </div>
      </div>

    </div>

    <FooterPage></FooterPage>

  </div>

</template>

<style scoped>

p {
  margin: 0;
}

.products_custom {
  padding: 1rem;
  width: 100%;
  background-color: white;
}

.img_products {
  width: 100%;
  height: 100%;
}

.div_stars {
  left: 50%;
  transform: translate(-50%);
  bottom: -8%;
  background-color: white;
  justify-content: center;
}

.off_percent {
  padding: .2rem;
  text-align: center;
  background-color: #d2d2d2;
}

.number_star {
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
}

.div_img_products {
  width: 9rem;
  height:9rem;
}

.information_products {
  direction: rtl;
  width: calc(100% - 9.5rem);
}
.information_products-web {
  direction: rtl;
  width: calc(100% - 10.5rem);
}

.existence {
  border: 1px solid #8C8C8CA0;
  background-color: #d2d2d2;
}

.list_products::-webkit-scrollbar {
  display: none;
}


.list_products_web {
  height: 70vh;
  display: flex;
  justify-content: space-between;
  align-content: baseline;
  flex-wrap: wrap;
}

.products_custom_web {
  padding: 1rem;
  background-color: white;
  flex-basis: 48%;
  flex-grow: 0;
}

.div_img_products_web {
  width: 10rem;
  height: 10rem;
  object-fit: cover;
}
</style>